import React, { useRef } from 'react'

const Skill = ({ icon, title, level = 85 }) => {
    const skillRef = useRef(null);

    return (
        <div 
            ref={skillRef}
            className='group transition-all ease-in-out duration-300 min-w-[130px] md:min-w-[200px] mb-8 flex flex-1 flex-col text-lg justify-center items-center text-white hover:scale-110'
        >
            <div className='relative p-4 flex-1 text-4xl rounded-full bg-gradient-to-br from-zinc-800 to-zinc-950 mb-4 shadow-lg group-hover:shadow-2xl group-hover:shadow-blue-500/50 transition-all duration-300'>
                <div className='absolute inset-0 rounded-full bg-gradient-to-br from-green-500/20 to-blue-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300' />
                <div className='relative z-10'>
                    {icon}
                </div>
            </div>
            <div className='flex-1 mb-2 font-semibold'>
                {title}
            </div>
            {/* <div className='w-full max-w-[120px] h-2 bg-zinc-800 rounded-full overflow-hidden'>
                <div 
                    className='h-full bg-gradient-to-r from-green-500 via-blue-500 to-purple-500 rounded-full transition-all duration-1000 ease-out'
                    style={{ width: `${progress}%` }}
                />
            </div> */}
            {/* <div className='text-xs text-zinc-400 mt-1'>{level}%</div> */}
        </div>
    )
}

export default Skill